module.exports = __webpack_public_path__ + "img/header_2.c38b1059.jpg";